module.exports = __webpack_public_path__ + "img/realboardTitle.66b29136.jpg";